var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-container"},[_c('div',[_vm._t("default")],2),_c('i',{staticClass:"fas fa-spinner fa-spin"})])])}
var staticRenderFns = []

export { render, staticRenderFns }